import { PLAUSIBLE_EVENTS } from './consts'

export function firePlausibleEvent(eventName: PLAUSIBLE_EVENTS) {
  if (window?.plausible) {
    window.plausible(eventName)
  }
}
